import { render, staticRenderFns } from "./VerifyEmailRegister.vue?vue&type=template&id=fbe20c2c&"
import script from "./VerifyEmailRegister.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailRegister.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports